import { render, staticRenderFns } from "./gj-log-table.vue?vue&type=template&id=2e99b025&scoped=true&"
import script from "./gj-log-table.vue?vue&type=script&lang=js&"
export * from "./gj-log-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99b025",
  null
  
)

export default component.exports